// extracted by mini-css-extract-plugin
module.exports = {"itineraryFields":"TimeTable_itineraryFields___CZVE","subHeading":"TimeTable_subHeading__2itZm"};